import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { usePlatformProfileService } from '../services/platformProfileService';

export const PlatformProfilesContext = createContext(null);

export const PlatformProfilesProvider = ({ children }) => {
  const { listProfiles, saveProfile: saveProfileApi } =
    usePlatformProfileService();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await listProfiles();
      if (result.success) {
        setProfiles(result.data?.profiles || []);
      } else {
        setProfiles([]);
        setError(result.error || 'Error al obtener los perfiles genéricos');
      }
    } catch (err) {
      setProfiles([]);
      setError(err.message || 'Error al obtener los perfiles genéricos');
    } finally {
      setLoading(false);
    }
  }, [listProfiles]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const saveProfile = useCallback(
    async (payload) => {
      const result = await saveProfileApi(payload);
      if (result.success) {
        await refetch();
      }
      return result;
    },
    [saveProfileApi, refetch]
  );

  const value = useMemo(
    () => ({
      profiles,
      loading,
      error,
      saveProfile,
      refetch,
    }),
    [profiles, loading, error, saveProfile, refetch]
  );

  return (
    <PlatformProfilesContext.Provider value={value}>
      {children}
    </PlatformProfilesContext.Provider>
  );
};
